import PropTypes from 'prop-types';

import {connect} from '@stubhub/react-store-provider';

import controller from './controller';
import RoyalMapView from './view';

const RoyalMap = connect(controller)(RoyalMapView);

RoyalMap.propTypes = {
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default RoyalMap;
